export default "__VITE_ASSET__a38ab8a4__"